import BrandName from '../constants/brand-name.map';
import LanguageCodeMapper from './language-code.mapper';
import DefaultBrandMap from '../constants/default-information.map';

const getBrandName = (brand) => {
  const brandName = brand ? brand.toLowerCase() : '';
  return BrandName[brandName] || DefaultBrandMap.brand;
};

const getKeyForLocale = (locale) => {
  const localeArr = locale.split('_');
  const localeKey = `${localeArr[0]}${localeArr[1]
    .charAt(0)
    .toUpperCase()}${localeArr[1].slice(1)}`;
  return localeKey;
};

/**
 * This method will get locale based upon brand domain and langid retrived using cookie/headers
 * @param {*} brand
 * @param {*} metaInfo
 */
const getLocale = (brand, metaInfo, host) => {
  // fetches method to obtain domain language selected by customer
  const getLanguageCodeMethod = LanguageCodeMapper[brand];
  const locale = getLanguageCodeMethod
    ? getLanguageCodeMethod(metaInfo, host)
    : DefaultBrandMap.locale;

  return locale;
};

const trimValue = (input) => {
  if (input) {
    return input.trim();
  }
  return '';
};

const getTpidEapid = (req) => {
  let tpid = '';
  let eapid = '';
  const defaultValue = { tpid, eapid };
  if (!req) {
    return defaultValue;
  }

  if (
    req.headers &&
    req.headers['x-expedia-eapid'] &&
    req.headers['x-expedia-tpid']
  ) {
    eapid = trimValue(req.headers['x-expedia-eapid']);
    tpid = trimValue(req.headers['x-expedia-tpid']);
    return { tpid, eapid };
  }

  return defaultValue;
};
export { getBrandName, getLocale, getKeyForLocale, getTpidEapid };
